/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import type { SearchRequest } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState, AllocatorSearchResult, RegionId } from '@modules/ui-types'

import { getAllocatorSearchResults } from '@/reducers/allocatorSearch'
import { searchAllocatorsRequest } from '@/reducers/asyncRequests/registry'

import { searchAllocators } from '../../actions/allocatorSearch'

import Allocators from './Allocators'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  searchResults: AllocatorSearchResult[] | undefined
  searchAllocatorsRequest: AsyncRequestState
}

type DispatchProps = {
  searchAllocators: ({
    queryId,
    regionId,
    payload,
  }: {
    queryId: string
    regionId?: RegionId
    payload?: SearchRequest
  }) => void
}

type ConsumerProps = {
  regionId: string
}

const mapStateToProps = (state: ReduxState, { regionId }: ConsumerProps): StateProps => ({
  searchResults: getAllocatorSearchResults(state, regionId, `allocators`),
  searchAllocatorsRequest: searchAllocatorsRequest(state, regionId, `allocators`),
})

const mapDispatchToProps: DispatchProps = {
  searchAllocators,
}

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Allocators)
